module.exports = __webpack_public_path__ + "static/scale-c8337002490f2aaf77e5560ff6458d3c.png";